import React, { Component, Fragment } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import queryString from 'query-string'

import { Title, Note, Button } from 'components/misc'
import { Header, LayoutPlain } from 'components/layout'
import { meta } from 'helpers/decorators'
import { apiPayment } from 'helpers/decorators/api'
import config from 'config'
import { MaterialLoader } from '../../../components/loaders'
import { FormattedMessage } from 'react-intl'

const STATUS = {
  START: 0, // API is contacted to process GP WP payment
  ERROR: -1, // something went wrong
  UPDATED: 1 // Payment has been successfully updated
}

@meta({
  title: 'Participant registration fees payment',
  intlKey: 'moduleTitle.payment'
})
@apiPayment()
class PaymentGPWPResult extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    processGpWp: PropTypes.func
  }

  state = {
    error: null,
    status: STATUS.START
  }

  componentDidMount = async() => {
    const query = queryString.parse(get(this.props, 'location.search'))

    if (typeof(query.PRCODE) === 'undefined') {
      this.setState({ status: STATUS.ERROR })
    }
    else {
      try {
        const success = await this.props.processGpWp()
        this.setState({ status: success ? STATUS.UPDATED : STATUS.ERROR })
      }
      catch (e) {
        console.error(e)
        this.setState({ status: STATUS.ERROR })
      }
    }
  }

  render() {
    const { status } = this.state

    return (
      <LayoutPlain
        header={<Header isLocaleHidden />}
        body={[
          <Fragment>
            <div>
              {status === STATUS.ERROR &&
              <Fragment>
                <Title h1 intlKey="moduleTitle.payment" className="base-margin--top">
                  Participant registration fees payment
                </Title>
                <Title h3 intlKey="label.problem_with_payment">
                  There was a problem processing your payment. Please contact your
                  National Award Operator (NAO).
                </Title>
              </Fragment>
              }

              {(status === STATUS.START) &&
              <h1>
                <MaterialLoader />{' '}
                <span style={{ marginLeft: 10, position: 'relative', top: -7 }}>
                    <FormattedMessage
                      id="label.loading_gp_gateway"
                      defaultMessage="Loading Global Payments Gateway"
                    />
                  </span>
              </h1>
              }

              {(status === STATUS.UPDATED) &&
                <Fragment>
                  <Title
                    h1
                    intlKey="moduleTitle.payment_successful"
                    className="base-margin--top"
                  >
                    Participant registration payment was successful
                  </Title>
                  <strong>
                    <Note intlKey="label.registration_updated">
                      This registration has been updated.
                    </Note>
                  </strong>
                  <Note intlKey="label.award_leader_receive_payment">
                    The Award Leader will receive information about the payment.
                  </Note>
                  <br />
                  <Button link to={`${config.publicPath}/`} intlKey="button.proceed_to_login">
                    Proceed to login page
                  </Button>
                </Fragment>
              }
            </div>
          </Fragment>
        ]}
      />
    )
  }
}

export default PaymentGPWPResult
